export default function(eventType, params) {
  if (typeof(pa) !== 'undefined') pa.sendEvent(eventType, params);
}



// WEBPACK FOOTER //
// ./src/helpers/at_internet/send_event_to_piano.js